import React from "react";
import { FadeUp } from "./FadeUp";
import { resolveTradeIcon, resolveTradeImage } from "../marketing/tradeIcons";
import type { TradeContent } from "../../types";

type TradesSectionProps = {
  trades?: TradeContent[];
};

export const TradesSection: React.FC<TradesSectionProps> = ({
  trades = [],
}) => (
  <section id="trades" className="py-24 bg-background">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 tracking-tight font-display">
            Built for trades
          </h2>
          <div className="w-24 h-1.5 bg-premium-500 mx-auto mb-8 rounded-full" />
          <p className="text-xl text-muted-foreground font-medium">
            Sole operator or a crew. Same $9.
          </p>
          <p className="text-lg text-muted-foreground mt-2">
            A site, job photos, and license tracking that match the work you do.
          </p>
        </div>
      </FadeUp>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {trades.map((trade, index) => {
          const Icon = resolveTradeIcon(trade.icon);
          return (
            <FadeUp key={trade.slug} delay={0.1 * (index + 1)}>
              <a
                href={`/for/${trade.slug}`}
                className="block bg-card rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-border group focus:outline-none focus-visible:ring-2 focus-visible:ring-premium-500"
              >
                <div className="h-48 overflow-hidden relative">
                  <div className="absolute inset-0 bg-neutral-900/30 group-hover:bg-neutral-900/10 transition-colors z-10" />
                  <img
                    src={resolveTradeImage(trade.imageKey)}
                    alt={trade.cardTitle}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6 relative">
                  <div className="absolute -top-8 right-6 w-14 h-14 bg-card border border-border text-premium-600 rounded-xl flex items-center justify-center shadow-lg z-20">
                    <Icon className="w-7 h-7" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground mb-2">
                    {trade.cardTitle}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {trade.cardDescription}
                  </p>
                </div>
              </a>
            </FadeUp>
          );
        })}
      </div>
    </div>
  </section>
);
